<span [ngClass]="clockType" [innerText]="parsedTimestamp | date : dateFilter"></span>
